// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { isMobileScreen, isTabletScreen, isWideScreen } from "@guestsupply/XDL/Utilities";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft, original } from "immer";

export type xItemReplacementsStateType = Readonly<{
    // key is for product id
    [key: string]: {
        carouselItemReplacement?: boolean; // to check if it has carousel of type replacement
        productItemReplacement?: boolean; // to check if it is coming from a PLP click in-order to scroll to carousel
    };
}>;

export const initialXItemReplacements: xItemReplacementsStateType = {};

const reducer = {
    "xItemReplacements/updateItemReplacements": (
        draft: Draft<xItemReplacementsStateType>,
        action: {
            data: {
                id: string;
                value: {
                    [key: string]: boolean;
                };
            };
        },
    ) => {
        if (draft[action.data.id]) {
            draft[action.data.id] = {
                ...draft[action.data.id],
                ...action.data.value,
            };
        } else {
            draft[action.data.id] = {
                ...action.data.value,
            };
        }
    },
};

const xItemReplacements = createTypedReducerWithImmer(initialXItemReplacements, reducer);

(reducers as any).xItemReplacements = xItemReplacements;

export type xItemReplacementsState = {
    xItemReplacements: xItemReplacementsStateType;
} & ApplicationState;

type xItemReplacementsReducers = {
    [key: string]: typeof xItemReplacements;
};

export type xItemReplacementsActions =
    | Parameters<xItemReplacementsReducers[keyof xItemReplacementsReducers]>[1]
    | AnyAction;
